export default __webpack_public_path__ + "static/media/Group 11949.5181321a.svg";